import { useSelector } from "react-redux";
import { ROUTES } from "../routes";
import IconApp from "../static/icons/apps.png";
import { permitUser } from "../components/Roles";
import { APP_USERS } from "../consts/AppRoles";
import {
  BLOCKED_FEATURES,
  isEmailBlockedForFeature,
} from "../utils/blockedEmails";
import { useMemo } from "react";

export const useSidebarRoutes = () => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const featureFlags = useSelector((state) => state.global.featureFlags);

  const PrimaryMenu = useMemo(() => {
    if (!featureFlags) return [];

    return [
      {
        name: "Dashboard",
        path: [ROUTES.DASHBOARD],
        icon: IconApp,
        show: permitUser(
          [...Object.values(APP_USERS)],
          currentUser?.productType
        ),
      },
      {
        name: "Cards",
        path: [ROUTES.CARDS.INDEX],
        icon: IconApp,
        show: permitUser(
          [...Object.values(APP_USERS)],
          currentUser?.productType
        ),
      },
      {
        name: "Drivers",
        path: [ROUTES.DRIVERS.INDEX],
        icon: IconApp,
        show: permitUser(
          [...Object.values(APP_USERS)],
          currentUser?.productType
        ),
      },
      {
        name: "Bulk Operation",
        path: [...Object.values(ROUTES.BULK_OPERAION)],
        icon: IconApp,
        show: permitUser(
          [...Object.values(APP_USERS)],
          currentUser?.productType
        ),
        children: [
          {
            name: "Load Card",
            path: [ROUTES.BULK_OPERAION.LOAD_CARD],
            show: permitUser(
              [
                APP_USERS.SUPER_DISTRIBUTOR,
                APP_USERS.DISTRIBUTOR,
                APP_USERS.CLIENT,
                APP_USERS.AGENT,
              ],
              currentUser?.productType
            ),
          },
          {
            name: "Load Drivers",
            path: [ROUTES.BULK_OPERAION.LOAD_DRIVER],
            show: false,
          },
          {
            name: "Card Summary",
            path: [ROUTES.BULK_OPERAION.CARD_SUMMARY],
            show: permitUser(
              [
                APP_USERS.SUPER_DISTRIBUTOR,
                APP_USERS.DISTRIBUTOR,
                APP_USERS.CLIENT,
                APP_USERS.AGENT,
              ],
              currentUser?.productType
            ),
          },
          {
            name: "Driver Summary",
            path: [ROUTES.BULK_OPERAION.DRIVER_SUMMARY],
            show: false,
          },
        ],
      },
      {
        name: "Reports",
        path: [...Object.values(ROUTES.REPORTS)],
        icon: IconApp,
        show: permitUser(
          [...Object.values(APP_USERS)],
          currentUser?.productType
        ),
        children: [
          {
            name: "Card Load",
            path: [ROUTES.REPORTS.CARD_LOAD],
            show: permitUser(
              [...Object.values(APP_USERS)],
              currentUser?.productType
            ),
          },
          {
            name: "Prefund",
            path: [ROUTES.REPORTS.PREFUND],
            show: permitUser(
              [...Object.values(APP_USERS)],
              currentUser?.productType
            ),
          },
          {
            name: "Ledger",
            path: [ROUTES.REPORTS.LEDGER],
            show: permitUser(
              [...Object.values(APP_USERS)],
              currentUser?.productType
            ),
          },
          {
            name: "B2B Payments",
            path: [ROUTES.REPORTS.B2B],
            show: permitUser(
              [...Object.values(APP_USERS)],
              currentUser?.productType
            ),
          },
          {
            name: "Claims & Advance Requests",
            path: [ROUTES.REPORTS.DRIVER_PAYMENT_REQ],
            show: permitUser(
              [...Object.values(APP_USERS)],
              currentUser?.productType
            ),
          },
        ],
      },
      {
        name: "Requests",
        path: [...Object.values(ROUTES.REQUESTS)],
        icon: IconApp,
        show: permitUser(
          [...Object.values(APP_USERS)],
          currentUser?.productType
        ),
        children: [
          {
            name: "Card Load",
            path: [ROUTES.REQUESTS.CARD_LOAD],
            show: permitUser(
              [
                APP_USERS.SUPER_DISTRIBUTOR,
                APP_USERS.DISTRIBUTOR,
                APP_USERS.CLIENT,
              ],
              currentUser?.productType
            ),
          },
          {
            name: "Prefund",
            path: [ROUTES.REQUESTS.PREFUND],
            show: permitUser(
              [
                APP_USERS.SUPER_DISTRIBUTOR,
                APP_USERS.DISTRIBUTOR,
                APP_USERS.CLIENT,
              ],
              currentUser?.productType
            ),
          },

          {
            name: "B2B Payments",
            path: [ROUTES.REQUESTS.B2B],
            show: permitUser(
              [
                APP_USERS.SUPER_DISTRIBUTOR,
                APP_USERS.DISTRIBUTOR,
                APP_USERS.CLIENT,
              ],
              currentUser?.productType
            ),
          },
          {
            name: "Claims & Advance Requests",
            path: [ROUTES.REQUESTS.DRIVER_PAYMENT_REQ],
            show: permitUser(
              [
                APP_USERS.SUPER_DISTRIBUTOR,
                APP_USERS.DISTRIBUTOR,
                APP_USERS.CLIENT,
                APP_USERS.AGENT,
              ],
              currentUser?.productType
            ),
          },
        ],
      },

      // wps
      {
        name: "WPS",
        show:
          !isEmailBlockedForFeature(
            BLOCKED_FEATURES.ALL,
            BLOCKED_FEATURES.ALL
          ) &&
          permitUser([...Object.values(APP_USERS)], currentUser?.productType) &&
          featureFlags.wpsEnabled,
        path: [...Object.values(ROUTES.WPS)],
        icon: IconApp,
      },
      {
        name: "Expense Management",
        show:
          featureFlags.expenseManagementEnabled &&
          permitUser([...Object.values(APP_USERS)], currentUser?.productType),
        path: [],
        icon: IconApp,
        isExternal: true,
      },
      // Store
      {
        name: "MoXey Store",
        show: permitUser(
          [...Object.values(APP_USERS)],
          currentUser?.productType
        ),
        path: [...Object.values(ROUTES.STORE)],
        icon: IconApp,
      },
    ];
  }, [featureFlags]);

  const FooterMenu = [
    {
      name: "Profile",
      path: [ROUTES.PROFILE],
      icon: IconApp,
      show: true,
    },
    {
      name: "Settings",
      path: [...Object.values(ROUTES.SETTINGS)],
      icon: IconApp,
      show: true,
      children: [
        {
          name: "Users",
          path: [ROUTES.SETTINGS.USERS],
          show: permitUser(
            [
              APP_USERS.SUPER_DISTRIBUTOR,
              APP_USERS.DISTRIBUTOR,
              APP_USERS.CLIENT,
            ],
            currentUser?.productType
          ),
        },
        {
          name: "Security",
          path: [ROUTES.SETTINGS.SECURITY],
          show: permitUser(
            [
              APP_USERS.SUPER_DISTRIBUTOR,
              APP_USERS.DISTRIBUTOR,
              APP_USERS.CLIENT,
              APP_USERS.AGENT,
            ],
            currentUser?.productType
          ),
        },

        {
          name: "Usage Report",
          path: [ROUTES.SETTINGS.USAGE_REPORT],
          show: permitUser(
            [
              APP_USERS.SUPER_DISTRIBUTOR,
              APP_USERS.DISTRIBUTOR,
              APP_USERS.CLIENT,
            ],
            currentUser?.productType
          ),
        },
        {
          name: "Help",
          path: [ROUTES.SETTINGS.HELP],
          show: permitUser(
            [
              APP_USERS.SUPER_DISTRIBUTOR,
              APP_USERS.DISTRIBUTOR,
              APP_USERS.CLIENT,
              APP_USERS.AGENT,
            ],
            currentUser?.productType
          ),
        },
        {
          name: "Account Details",
          path: [ROUTES.SETTINGS.ACCOUNT_DETAILS],
          show: permitUser(
            [
              APP_USERS.SUPER_DISTRIBUTOR,
              APP_USERS.DISTRIBUTOR,
              APP_USERS.CLIENT,
              APP_USERS.AGENT,
            ],
            currentUser?.productType
          ),
        },
        {
          name: "Expense Management",
          path: [ROUTES.SETTINGS.EXPENSE_MANAGEMENT],
          show: permitUser(
            [
              APP_USERS.SUPER_DISTRIBUTOR,
              APP_USERS.DISTRIBUTOR,
              APP_USERS.CLIENT,
              APP_USERS.AGENT,
            ],
            currentUser?.productType
          ),
        },
      ],
    },

    {
      name: "Logout",
      path: [ROUTES.LOGOUT],
      icon: IconApp,
      show: true,
    },
  ];
  return { PrimaryMenu, FooterMenu };
};
